import { Contact } from '../../features/contacts/contact.model';
import { TeamMember } from '../../features/team/team.model';
import { Company } from '../../features/companies/company.model';
import { EventBB } from '../../features/events/event.model';
import { Project } from '../../features/projects/project.model';
import { Purchase } from '../../features/projects/purchase.model';
import { Payment } from '../payments/payment.model';

export class Task {

    _id?: string;

    completed: boolean = false;
    subject: string;
    // taskType: string;
    status: string = 'Not Started';
    priority: string = 'Normal';
    dueDate: Date = new Date();
    reminderDate: Date;
    summary: string;

    /* people involved */
    assignedTo: TeamMember[] = [];
    contacts: Contact[] = [];
    payment: Payment;
    companies: Company[] = [];
    projects: Project[] = [];
    purchases: Purchase[] = [];
    events: EventBB[] = [];

    /* further details */
    createdBy?: string;
    modifiedBy?: string;
    createdAt?: Date;
    modifiedAt?: Date;

}



// WEBPACK FOOTER //
// ./client/app/shared/tasks/task.model.ts